// extracted by mini-css-extract-plugin
module.exports = {"table":"ImportCatalogShow_table__2g-qI","error":"ImportCatalogShow_error__2wnaJ"};